export { default as GuarenteeSection } from './GuarenteeSection'
export { default as HeaderSection } from './HeaderSection'
export { default as BedroomSection } from './BedroomSection'
export { default as OutdoorSection } from './OutdoorSection'
export { default as FloatingHeaderSection } from './FloatingHeaderSection'
export { default as RoomsSection } from './RoomsSection'
export { default as FeaturedItems } from './FeaturedItems'

